import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Card, Form, Button, Spinner, Image } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { ToastContainer } from "react-toastify";
import { generateOtp, login, resetLogin, resetOtp } from "./actions";
import InicImg from "../../assets/images/InicImg.png";
import loginsvg from "../../assets/images/login-page-img.svg";
import {
  setItem,
  showErrorToast,
  showOtpToast,
  showSuccessToast,
} from "../../utils/Functions";
import regexUtils from "../../utils/regexUtils";

const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const otpData = useSelector((state) => state.login);
  const loginData = useSelector((state) => state.login.login);
  const [isLoading, setIsLoading] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [seconds, setSeconds] = useState(30);
  const [showTimer, setShowTimer] = useState(false);
  const [showResendButton, setShowResendButton] = useState(false);

  const [data, setData] = useState({
    emailId: "",
    otp: "",
  });

  const [errors, setErrors] = useState({
    emailId: "",
    otp: "",
  });

  useEffect(() => {
    localStorage.removeItem("emailId");
    setData({ ...data, emailId: "" });
    setIsOtpSent(false);
  }, []);

  useEffect(() => {
    let timer;
    if (showTimer && seconds > 0) {
      timer = setInterval(
        () => setSeconds((prevSeconds) => prevSeconds - 1),
        1000
      );
    } else if (seconds === 0) {
      clearInterval(timer);
      setShowResendButton(true);
      setShowTimer(false);
    }

    return () => clearInterval(timer);
  }, [seconds, showTimer]);

  useEffect(() => {
    if (loginData && loginData.status === 1) {
      setItem("isLoggedIn", true);
      setItem("type", loginData.type);
      setItem("qualification", loginData.data.qualification);
      showSuccessToast(loginData.message);

      dispatch(resetLogin());

      setTimeout(() => {
        history.push("/home");
        localStorage.removeItem("emailId");
      }, 1000);
    } else if (loginData && loginData.status === 0) {
      showErrorToast(loginData.message);
      setData({ ...data, otp: "" });
    }
  }, [loginData]);

  useEffect(() => {
    if (Object.keys(otpData.data).length > 0) {
      setIsLoading(false);

      if (otpData.data && otpData.data.status === 1) {
        setIsOtpSent(true);
        setShowTimer(true);
        setSeconds(30);
        setShowResendButton(false);
        setItem("emailId", data.emailId);
        showOtpToast(otpData.data.message);
      } else {
        showErrorToast(otpData.data.message);
      }
    }
  }, [otpData]);

  const validateEmail = () => {
    let isValid = true;
    let error = { emailId: "" };

    if (data.emailId === "") {
      error.emailId = "Email Address is required";
      isValid = false;
    } else if (!new RegExp(regexUtils.emailRegex).test(data.emailId)) {
      error.emailId = "Please enter valid email.";
      isValid = false;
    }

    setErrors({ ...errors, emailId: error.emailId });
    return isValid;
  };

  const validateOtp = () => {
    let isValid = true;
    let error = { otp: "" };

    if (data.otp === "") {
      error.otp = "OTP is required";
      isValid = false;
    }

    setErrors({ ...errors, otp: error.otp });
    return isValid;
  };

  const handleSendOtp = () => {
    if (validateEmail()) {
      setIsLoading(true);
      dispatch(generateOtp({ emailId: data.emailId }));
    }
  };

  const handleResendOtp = () => {
    setIsLoading(true);
    setSeconds(30);
    setShowTimer(true);
    setShowResendButton(false);
    dispatch(generateOtp({ emailId: data.emailId }));
  };

  const handleLogin = (e) => {
    e.preventDefault();
    if (validateOtp()) {
      dispatch(
        login({
          emailId: data.emailId,
          otp: data.otp,
        })
      );
      dispatch(resetOtp());
    }
  };

  return (
    <>
      <div className="main-containt h-100">
        <div className="loginScreen">
          <div
            className="loginScreen__wrapper"
            style={{ "--bgImage": `url(${loginsvg})` }}
          >
            <div className="loginScreen__content">
              <div className="white-box">
                <Image
                  src={InicImg}
                  alt="IndiaNIC Logo"
                  className="mb-2"
                  fluid
                />
                <h1 className="mb-0">Candidate Portal</h1>
              </div>
              <Image
                src={loginsvg}
                alt="Login Images"
                fluid
                className="imgbg"
              />
            </div>
            <div className="loginScreen__form">
              <div className="loginScreen__form-body">
                <div className="login-content">
                  <Card className="login-model border-0">
                    <h3 className="title border-0">
                      Get more than just a job.
                    </h3>
                    <Card.Body className="text-center">
                      <Form onSubmit={handleLogin}>
                        {!isOtpSent && (
                          <>
                            <div
                              className={
                                errors.emailId
                                  ? "error-red otp-input-box"
                                  : "otp-input-box"
                              }
                            >
                              <Form.Group className="icon-input">
                                <span className="ct-icon icon-contact-mail">
                                  <span className="path1"></span>
                                  <span className="path2"></span>
                                  <span className="path3"></span>
                                </span>
                                <Form.Control
                                  type="text"
                                  value={data.emailId}
                                  placeholder={"Login with Email ID"}
                                  className={
                                    errors.emailId
                                      ? "border-0 p-0 ml-1 error-input"
                                      : "border-0 p-0 ml-1"
                                  }
                                  onChange={(e) => {
                                    setData({
                                      ...data,
                                      emailId: e.target.value,
                                    });
                                    setErrors({ ...errors, emailId: "" });
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter" && !isOtpSent) {
                                      e.preventDefault();
                                      handleSendOtp();
                                    }
                                  }}
                                />
                              </Form.Group>
                            </div>
                            {errors.emailId && (
                              <div className="text-left mb-2">
                                <span
                                  className="error-msg"
                                  style={{ color: "red", fontSize: "12px" }}
                                >
                                  {errors.emailId}
                                </span>
                              </div>
                            )}
                          </>
                        )}

                        {!isOtpSent && (
                          <Button
                            variant="primary"
                            className="mt-4 submit-btn theme-btn text-nowrap"
                            onClick={handleSendOtp}
                            disabled={isLoading}
                          >
                            Send OTP{" "}
                            {isLoading && (
                              <Spinner animation="border" size="sm" />
                            )}
                          </Button>
                        )}

                        {isOtpSent && (
                          <>
                            <Form.Group className="otp-number-input-wrap mt-4">
                              <div className="otp-number-input">
                                <OtpInput
                                  value={data.otp}
                                  className={
                                    errors.otp
                                      ? "otp border-0 error-red"
                                      : "otp border-0"
                                  }
                                  onChange={(otp) => {
                                    setData({ ...data, otp });
                                    setErrors({ ...errors, otp: "" });
                                  }}
                                  numInputs={6}
                                />
                              </div>
                              {errors.otp && (
                                <div className="text-left mt-2">
                                  <span
                                    className="error-msg"
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {errors.otp}
                                  </span>
                                </div>
                              )}
                            </Form.Group>

                            <div className="mt-3 mb-4">
                              {showTimer && (
                                <p className="fs-14 text-center mb-0">
                                  Resend OTP in{" "}
                                  {seconds > 9 ? seconds : `0${seconds}`}{" "}
                                  seconds
                                </p>
                              )}

                              {showResendButton && (
                                <Button
                                  variant="link"
                                  className="p-0 text-primary"
                                  onClick={handleResendOtp}
                                  disabled={isLoading}
                                >
                                  Resend OTP{" "}
                                  {isLoading && (
                                    <Spinner animation="border" size="sm" />
                                  )}
                                </Button>
                              )}
                              <p>
                                <Button
                                  variant="link"
                                  className="p-0 text-primary"
                                  onClick={() => {
                                    setIsOtpSent(false);
                                    setData({ ...data, emailId: "" });
                                    setErrors({ ...errors, emailId: "" });
                                  }}
                                >
                                  Back to Login
                                </Button>
                              </p>
                            </div>

                            <Button
                              className="theme-btn submit-btn"
                              type="submit"
                              disabled={!data.otp || data.otp.length < 6}
                            >
                              Submit
                            </Button>
                          </>
                        )}
                      </Form>
                    </Card.Body>
                  </Card>
                </div>
                <ToastContainer />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
